
import { Component, Vue } from 'vue-facing-decorator'
import OrderItem from '../index/com/table-body/order-item.vue'
import TableHead from '../index/com/table-head/index.vue'
import { getPayTypeText } from '@/common/pay'

@Component({
  components: {
    OrderItem,
    TableHead,
  },
})
export default class extends Vue {
  loading = false;
  formData: any = {};

  async created() {
    this.loading = true;
    let { error, data } = await this.$post("/manager/order/view", {
      id: this.$route.query.id,
    });
    this.loading = false;
    if (error) return this.$error("获取订单信息失败");
    this.formData = data || {};
  }

  getPayTypeText = getPayTypeText;
}
